// Hero backgrounds used to be routed through an encrypt-then-proxy chain: a
// POST to an AWS API Gateway to sign the URL, rebuilt against an EC2 image
// server, base64'd, then fetched via marvin-proxy. That EC2 box is gone and
// the proxy leg returns ERR_BLOCKED_BY_ORB, so the chain only ever produced a
// broken background. Point the element straight at the path instead.
export const bgImageDirective = {
  mounted: function (el, binding) {
    if (!binding.value) {
      return;
    }
    el.style.backgroundImage = `url(${binding.value})`;
  }
};
